/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { DeliveryMetric } from 'cio/utils/metrics/measure';

interface Channel {
  label: string;
  value: 'email' | 'twilio' | 'push' | 'in_app' | 'slack' | 'webhook';
}

interface Measure {
  label: string;
  value: DeliveryMetric;
}

interface Cell {
  isAvailable: boolean;
  isConditional: boolean;
}

interface Row {
  label: string;
  cells: Cell[];
}

export default class ChannelMeasuresTooltip extends Component {
  readonly definitionTableMeasures: Measure[] = [
    {
      label: 'Delivered',
      value: DeliveryMetric.delivered,
    },
    {
      label: 'Opened',
      value: DeliveryMetric.opened,
    },
    {
      label: 'Clicked',
      value: DeliveryMetric.clicked,
    },
    {
      label: 'Converted',
      value: DeliveryMetric.converted,
    },
    {
      label: 'Bounced',
      value: DeliveryMetric.bounced,
    },
    {
      label: 'Suppressed',
      value: DeliveryMetric.suppressed,
    },
    {
      label: 'Spammed',
      value: DeliveryMetric.spammed,
    },
    {
      label: 'Unsubscribes',
      value: DeliveryMetric.unsubscribed,
    },
    {
      label: 'Unsubscribes from topics',
      value: DeliveryMetric.topicUnsubscribed,
    },
  ];
  readonly definitionTableChannels: Channel[] = [
    {
      label: 'Email',
      value: 'email',
    },
    {
      label: 'SMS',
      value: 'twilio',
    },
    {
      label: 'Push',
      value: 'push',
    },
    {
      label: 'In-App',
      value: 'in_app',
    },
    {
      label: 'Slack',
      value: 'slack',
    },
    {
      label: 'Webhook',
      value: 'webhook',
    },
  ];
  availableChannelMeasures: Record<Channel['value'], Measure['value'][]> = {
    email: [
      DeliveryMetric.opened,
      DeliveryMetric.clicked,
      DeliveryMetric.converted,
      DeliveryMetric.delivered,
      DeliveryMetric.bounced,
      DeliveryMetric.suppressed,
      DeliveryMetric.spammed,
      DeliveryMetric.unsubscribed,
      DeliveryMetric.topicUnsubscribed,
    ],
    twilio: [DeliveryMetric.delivered, DeliveryMetric.converted, DeliveryMetric.bounced],
    push: [
      DeliveryMetric.delivered,
      DeliveryMetric.opened,
      DeliveryMetric.converted,
      DeliveryMetric.bounced,
      DeliveryMetric.suppressed,
    ],
    in_app: [DeliveryMetric.opened, DeliveryMetric.clicked, DeliveryMetric.converted],
    slack: [],
    webhook: [DeliveryMetric.converted],
  };

  get measureTableRows(): Row[] {
    let rows: Row[] = [];

    this.definitionTableChannels.forEach((channel) => {
      let row: Row = { label: channel.label, cells: [] };

      this.definitionTableMeasures.forEach((measure) => {
        let isAvailable = this.availableChannelMeasures[channel.value].includes(measure.value);
        row.cells.push({
          isAvailable,
          isConditional: this.isConditional(measure.value, channel.value),
        });
      });

      rows.push(row);
    });

    return rows;
  }

  private isConditional(measure: Measure['value'], channel: Channel['value']) {
    return (
      (channel === 'push' && (measure === 'opened' || measure === 'delivered')) ||
      (channel === 'webhook' && measure === 'converted')
    );
  }
}
